import React from "react";
// import React, { useState, useEffect } from "react";

import { smallIcons } from "../constants";
import { Link } from "react-router-dom";
// import HomePage from "./HomePage";

export const Navbar = () => {
  return (
    <div className="max-width">
      <div className="navbar-container max-width">
        <div className="nav-list">
          <div className="bar-ct">
            <span className="bar"> </span>
            <span className="bar"> </span>
            <span className="bar"> </span>
            <span className="cerrar">Cerrar</span>
          </div>
          <Link to="/HomePage">
            {" "}
            <p className="menu">MENU</p>
          </Link>
        </div>
        <div className="nav-logo">
          <p>
            <a href="/">PRIMER EQUIPO</a>
          </p>
          <p>
            <Link to="/FemPage"> EQUIPO FEMENINO</Link>
          </p>
          <p className="nav-psg-text">{"  "} PSG TV</p>
        </div>
        <div className="sign-up">
          <img src={smallIcons[3].icon} alt="psg Logo" />

          <img src={smallIcons[2].icon} alt="psg Logo" />

          <img src={smallIcons[1].icon} alt="psg Logo" />
        </div>
      </div>
    </div>
  );
};
